import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu'
import makeStyles from '@material-ui/core/styles/makeStyles';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import Actions from './Actions';
import { useParams, useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    toolbar: theme.mixins.toolbar,
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: 'none',
        backgroundColor: '#10457A',
        borderBottom: 'solid 0.25rem #1474d4'
    },
    toolbarStyle: {
        minHeight: 'auto',
        padding: '1rem',
    },
    titleStyle: {
        fontWeight: 700
    }
}));

const Spacer = styled.span`
    flex: 1 1 auto;
`;

const MenuButton = styled(Button)`
    padding: 0;
    min-width: 45px;
    font-size: 2rem;
    color: #1474d4;
    align-self: center;
    border: 1px solid #1474d4;
`

const Navbar = ({ menuItems, title, toggleMenu }) => {
    const classes = useStyles();
    const history = useHistory();
    const [pageIndex, setPageIndex] = React.useState(0);
    const { parentslug, childslug } = useParams();

    React.useEffect(() => {
        let index = menuItems.findIndex(m => m.slug === `/${childslug}`);
        if (index !== -1) {
            setPageIndex(index);
        }
    }, [parentslug, childslug]);


    const previousPage = (page) => {
        setPageIndex(pageIndex - 1);
        history.push(`/${parentslug}${page.slug}`);
    }
    const nextPage = (page) => {
        setPageIndex(pageIndex + 1);
        history.push(`/${parentslug}${page.slug}`);
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar className={classes.toolbarStyle}>
                    {title && <Typography variant="h6" noWrap className={classes.titleStyle}>
                        {title}
                    </Typography>}
                    <Spacer />
                    <Hidden smUp implementation="css">
                        <MenuButton
                            aria-label="open drawer"
                            edge="start"
                            onClick={toggleMenu}

                        >
                            <MenuIcon fontSize="inherit" />
                        </MenuButton>
                    </Hidden>
                    <Hidden xsDown implementation="css">
                        <Actions
                            pageIndex={pageIndex}
                            item={menuItems}
                            nextPage={nextPage}
                            previousPage={previousPage} />
                    </Hidden>
                </Toolbar>
            </AppBar>
        </React.Fragment>
    )
}
Navbar.propType = {
    title: PropTypes.string,
    menuItems: PropTypes.arrayOf(PropTypes.any).isRequired,
    toggleMenu: PropTypes.func.isRequired,
    onPageChange: PropTypes.func
}
Navbar.defaulProps = {
    title: null,
    onPageChange: null
}
export default Navbar;


// WEBPACK FOOTER //
// ./src/Components/Navbar/index.js